import React from 'react'
import Product from '../../components/Products/Products'
import Info from '../../components/Info/Info'
import Feature from '../../components/Feature/Feature'

const Products = () => {
  return (
    <div>
        <Product/>
        <Feature/>
        <Info/>
    </div>
  )
}

export default Products